import { createAction } from "redux-act";

export const REQNotificationDetail = createAction("REQUEST_NOTIFICATION_DETAIL");
export const RESNotificationDetail = createAction("RECEIVE_NOTIFICATION_DETAIL");
export const SAVExNotification = createAction("SAVE_NOTIFICATION");
export const SAVEDxNotification = createAction("SAVED_NOTIFICATION");
export const PREVIEWxAudience = createAction("PREVIEW_NOTIFICATION_AUDIENCE");
export const RESPreviewAudience = createAction("RECEIVE_NOTIFICATION_AUDIENCE");
export const FailNotificationDetail = createAction("FAILED_NOTIFICATION_DETAIL");
export const CleanUpNotificationDetail = createAction("CLEANUP_NOTIFICATION_DETAIL");
